import { render, staticRenderFns } from "./SectorsEdit.vue?vue&type=template&id=07239673&scoped=true&"
import script from "./SectorsEdit.vue?vue&type=script&lang=js&"
export * from "./SectorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07239673",
  null
  
)

export default component.exports